/**
 * Escape special characters to create a regexp
 *
 * @type {(string: string) => string}
 */
const escapeString = (string) => string.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&')

module.exports = { escapeString }
